module.exports = __webpack_public_path__ + "static/media/companyculture03.8b3711ef.png";